import { Button } from "@cirrus/ui-kit/src/components/molecules/button/index.js"

// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import { styled } from "@mui/material"
import React from "react"
import { Form, FormSpy } from "react-final-form"
import { FiltersContainer } from "."
import { useTableContext } from "../../provider"

const ResetButton = styled(Button)({
  "&[class*='MuiButton-outlined']": {
    "&:hover": {
      borderColor: "#80564655"
    },
    borderColor: "#80564655",
    marginTop: "24px"
  }
})

export const FiltersForm = ({
                              children,
                              onChange = (values: any) => undefined,
                              onReset = () => undefined,
                            }) => {

  const ctx = useTableContext()

  return (
    <Form
      initialValues={ctx.filters.state.values}
      onSubmit={() => undefined}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <FormSpy
            onChange={(props) => {
              if (props.dirty) {
                onChange(props.values)
              }
            }}
          />
          <FiltersContainer xs={12}>
            {children}
          </FiltersContainer>

          <ResetButton
            label={i18n("General:ResetFilters")}
            variant={"outlined"}
            onClick={onReset}
          />
        </form>
      )}
    />
  )
}
